"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.priceBookGovernanceResponseSchema = exports.priceBookImportReviewSchema = exports.priceBookImportErrorSchema = exports.priceBookImportRequestSchema = exports.priceBookComparisonResponseSchema = exports.priceBookComparisonItemSchema = exports.restorePriceBookVersionRequestSchema = exports.publishPriceBookDraftRequestSchema = exports.upsertPriceBookDraftItemRequestSchema = exports.createPriceBookDraftRequestSchema = exports.priceBookWorkspaceQuerySchema = exports.priceBookVersionSchema = exports.priceBookVersionItemSchema = exports.priceBookVersionSummarySchema = exports.catalogListResponseSchema = exports.catalogItemSchema = exports.catalogCategorySchema = exports.updateCatalogItemStatusRequestSchema = exports.updateCatalogItemRequestSchema = exports.createCatalogItemRequestSchema = exports.priceBookItemInheritanceSchema = exports.priceBookVersionStatusSchema = exports.priceBookScopeTypeSchema = exports.PRICE_BOOK_CSV_COLUMNS = exports.PRICE_BOOK_CSV_SCHEMA_VERSION = exports.catalogItemStatusSchema = exports.catalogPricingUnitSchema = exports.catalogItemTypeSchema = exports.catalogItemIdSchema = void 0;
const zod_1 = require("zod");
exports.catalogItemIdSchema = zod_1.z.string().uuid();
exports.catalogItemTypeSchema = zod_1.z.enum(["SERVICE", "MATERIAL"]);
exports.catalogPricingUnitSchema = zod_1.z.enum(["FLAT_RATE", "HOUR", "EACH"]);
exports.catalogItemStatusSchema = zod_1.z.enum(["ACTIVE", "ARCHIVED"]);
exports.PRICE_BOOK_CSV_SCHEMA_VERSION = "crewfsm-price-book.v1";
exports.PRICE_BOOK_CSV_COLUMNS = [
    "schema_version",
    "item_id",
    "code",
    "name",
    "description",
    "category",
    "type",
    "pricing_unit",
    "unit_price_cents",
    "unit_cost_cents",
    "taxable",
    "estimated_duration_minutes",
    "status",
    "inheritance",
];
exports.priceBookScopeTypeSchema = zod_1.z.enum([
    "ORGANIZATION_DEFAULT",
    "LOCATION_OVERRIDE",
]);
exports.priceBookVersionStatusSchema = zod_1.z.enum([
    "DRAFT",
    "SCHEDULED",
    "PUBLISHED",
    "SUPERSEDED",
]);
exports.priceBookItemInheritanceSchema = zod_1.z.enum([
    "DEFAULT",
    "OVERRIDE",
    "EXCLUDED",
]);
const optionalText = (maxLength) => zod_1.z
    .string()
    .trim()
    .max(maxLength)
    .optional()
    .transform((value) => value || undefined);
const catalogItemInputSchema = zod_1.z
    .object({
    name: zod_1.z.string().trim().min(2).max(160),
    code: zod_1.z
        .string()
        .trim()
        .max(40)
        .transform((value) => value.toUpperCase())
        .pipe(zod_1.z
        .string()
        .regex(/^[A-Z0-9][A-Z0-9._-]*$/, "Code can use letters, numbers, dots, dashes, and underscores."))
        .optional()
        .transform((value) => value || undefined),
    description: optionalText(2_000),
    categoryName: optionalText(80),
    type: exports.catalogItemTypeSchema,
    pricingUnit: exports.catalogPricingUnitSchema,
    unitPriceCents: zod_1.z.number().int().min(0).max(100_000_000),
    unitCostCents: zod_1.z.number().int().min(0).max(100_000_000).optional(),
    taxable: zod_1.z.boolean(),
    estimatedDurationMinutes: zod_1.z.number().int().min(5).max(1_440).optional(),
})
    .superRefine((value, context) => {
    if (value.type === "MATERIAL" && value.pricingUnit === "HOUR") {
        context.addIssue({
            code: "custom",
            path: ["pricingUnit"],
            message: "Materials cannot use hourly pricing.",
        });
    }
    if (value.type === "MATERIAL" &&
        value.estimatedDurationMinutes !== undefined) {
        context.addIssue({
            code: "custom",
            path: ["estimatedDurationMinutes"],
            message: "Only services can have an estimated duration.",
        });
    }
});
exports.createCatalogItemRequestSchema = catalogItemInputSchema;
exports.updateCatalogItemRequestSchema = catalogItemInputSchema;
exports.updateCatalogItemStatusRequestSchema = zod_1.z.object({
    status: exports.catalogItemStatusSchema,
});
exports.catalogCategorySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    name: zod_1.z.string(),
});
exports.catalogItemSchema = zod_1.z.object({
    id: exports.catalogItemIdSchema,
    name: zod_1.z.string(),
    code: zod_1.z.string().nullable(),
    description: zod_1.z.string().nullable(),
    category: exports.catalogCategorySchema.nullable(),
    type: exports.catalogItemTypeSchema,
    pricingUnit: exports.catalogPricingUnitSchema,
    unitPriceCents: zod_1.z.number().int().nonnegative(),
    unitCostCents: zod_1.z.number().int().nonnegative().nullable(),
    taxable: zod_1.z.boolean(),
    estimatedDurationMinutes: zod_1.z.number().int().positive().nullable(),
    status: exports.catalogItemStatusSchema,
    createdAt: zod_1.z.string().datetime(),
    updatedAt: zod_1.z.string().datetime(),
});
exports.catalogListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.catalogItemSchema),
    total: zod_1.z.number().int().nonnegative(),
});
const priceBookVersionIdentitySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    versionNumber: zod_1.z.number().int().positive(),
    scopeType: exports.priceBookScopeTypeSchema,
    locationId: zod_1.z.string().uuid().nullable(),
});
exports.priceBookVersionSummarySchema = priceBookVersionIdentitySchema.extend({
    status: exports.priceBookVersionStatusSchema,
    effectiveAt: zod_1.z.string().datetime(),
    basedOnVersionId: zod_1.z.string().uuid().nullable(),
    revision: zod_1.z.number().int().nonnegative(),
    itemCount: zod_1.z.number().int().nonnegative(),
    createdByMembershipId: zod_1.z.string().uuid(),
    approvedByMembershipId: zod_1.z.string().uuid().nullable(),
    createdAt: zod_1.z.string().datetime(),
    publishedAt: zod_1.z.string().datetime().nullable(),
    updatedAt: zod_1.z.string().datetime(),
});
exports.priceBookVersionItemSchema = exports.catalogItemSchema.extend({
    priceBookVersionId: zod_1.z.string().uuid(),
    inheritance: exports.priceBookItemInheritanceSchema,
});
exports.priceBookVersionSchema = exports.priceBookVersionSummarySchema.extend({
    items: zod_1.z.array(exports.priceBookVersionItemSchema),
});
exports.priceBookWorkspaceQuerySchema = zod_1.z
    .object({
    scopeType: exports.priceBookScopeTypeSchema.default("ORGANIZATION_DEFAULT"),
    locationId: zod_1.z.string().uuid().optional(),
})
    .superRefine((value, context) => {
    if (value.scopeType === "LOCATION_OVERRIDE" && !value.locationId) {
        context.addIssue({
            code: "custom",
            path: ["locationId"],
            message: "A location is required for a location override.",
        });
    }
    if (value.scopeType === "ORGANIZATION_DEFAULT" && value.locationId) {
        context.addIssue({
            code: "custom",
            path: ["locationId"],
            message: "Organization defaults cannot target one location.",
        });
    }
});
exports.createPriceBookDraftRequestSchema = exports.priceBookWorkspaceQuerySchema.extend({
    sourceVersionId: zod_1.z.string().uuid().optional(),
});
exports.upsertPriceBookDraftItemRequestSchema = catalogItemInputSchema
    .extend({
    id: exports.catalogItemIdSchema.optional(),
    status: exports.catalogItemStatusSchema.default("ACTIVE"),
    inheritance: exports.priceBookItemInheritanceSchema.default("DEFAULT"),
})
    .superRefine((value, context) => {
    if (value.inheritance === "EXCLUDED" && value.status !== "ARCHIVED") {
        context.addIssue({
            code: "custom",
            path: ["status"],
            message: "Excluded items must be archived in this location.",
        });
    }
});
exports.publishPriceBookDraftRequestSchema = zod_1.z.object({
    effectiveAt: zod_1.z.string().datetime(),
    expectedRevision: zod_1.z.number().int().nonnegative(),
});
exports.restorePriceBookVersionRequestSchema = exports.priceBookWorkspaceQuerySchema;
exports.priceBookComparisonItemSchema = zod_1.z.object({
    itemId: exports.catalogItemIdSchema,
    code: zod_1.z.string().nullable(),
    name: zod_1.z.string(),
    change: zod_1.z.enum(["ADDED", "REMOVED", "CHANGED"]),
    changedFields: zod_1.z.array(zod_1.z.enum([
        "name",
        "code",
        "description",
        "category",
        "type",
        "pricingUnit",
        "unitPriceCents",
        "unitCostCents",
        "taxable",
        "estimatedDurationMinutes",
        "status",
        "inheritance",
    ])),
});
exports.priceBookComparisonResponseSchema = zod_1.z.object({
    fromVersionId: zod_1.z.string().uuid(),
    toVersionId: zod_1.z.string().uuid(),
    items: zod_1.z.array(exports.priceBookComparisonItemSchema),
    totals: zod_1.z.object({
        added: zod_1.z.number().int().nonnegative(),
        removed: zod_1.z.number().int().nonnegative(),
        changed: zod_1.z.number().int().nonnegative(),
    }),
});
exports.priceBookImportRequestSchema = zod_1.z
    .object({
    fileName: zod_1.z.string().trim().min(1).max(255),
    csv: zod_1.z.string().min(1).max(5_000_000),
    scopeType: exports.priceBookScopeTypeSchema.default("ORGANIZATION_DEFAULT"),
    locationId: zod_1.z.string().uuid().optional(),
})
    .superRefine((value, context) => {
    if (value.scopeType === "LOCATION_OVERRIDE" && !value.locationId) {
        context.addIssue({
            code: "custom",
            path: ["locationId"],
            message: "A location is required for a location override.",
        });
    }
    if (value.scopeType === "ORGANIZATION_DEFAULT" && value.locationId) {
        context.addIssue({
            code: "custom",
            path: ["locationId"],
            message: "Organization defaults cannot target one location.",
        });
    }
});
exports.priceBookImportErrorSchema = zod_1.z.object({
    rowNumber: zod_1.z.number().int().positive(),
    code: zod_1.z.enum([
        "HEADER_INVALID",
        "COLUMN_COUNT_INVALID",
        "FIELD_INVALID",
        "DUPLICATE_ITEM_ID",
        "DUPLICATE_CODE",
    ]),
    field: zod_1.z.string().nullable(),
    message: zod_1.z.string(),
});
exports.priceBookImportReviewSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    schemaVersion: zod_1.z.literal(exports.PRICE_BOOK_CSV_SCHEMA_VERSION),
    fileName: zod_1.z.string(),
    scopeType: exports.priceBookScopeTypeSchema,
    locationId: zod_1.z.string().uuid().nullable(),
    status: zod_1.z.enum(["READY", "INVALID", "APPLIED"]),
    rowCount: zod_1.z.number().int().nonnegative(),
    validRowCount: zod_1.z.number().int().nonnegative(),
    errors: zod_1.z.array(exports.priceBookImportErrorSchema),
    draftVersionId: zod_1.z.string().uuid().nullable(),
    createdAt: zod_1.z.string().datetime(),
    appliedAt: zod_1.z.string().datetime().nullable(),
});
exports.priceBookGovernanceResponseSchema = zod_1.z.object({
    scope: zod_1.z.object({
        organizationId: zod_1.z.string().uuid(),
        tenantId: zod_1.z.string().uuid(),
        businessId: zod_1.z.string().uuid(),
        scopeType: exports.priceBookScopeTypeSchema,
        locationId: zod_1.z.string().uuid().nullable(),
    }),
    canManage: zod_1.z.boolean(),
    canApprove: zod_1.z.boolean(),
    current: exports.priceBookVersionSummarySchema.nullable(),
    draft: exports.priceBookVersionSchema.nullable(),
    history: zod_1.z.array(exports.priceBookVersionSummarySchema),
});
//# sourceMappingURL=catalog.js.map